import React from 'react';

import NotificationModal from '../components/notificationModal';

function ContactLogs() {
  return (<NotificationModal />);
}

export default ContactLogs;
